import { Link } from "react-router-dom";
import logoLight from "@/assets/mark-tognoli-realty-logo-light.png";

const Footer = () => {
  return (
    <footer className="bg-brand-charcoal text-brand-ivory">
      <div className="container mx-auto max-w-[1400px] px-6 py-20">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <img
              src={logoLight}
              alt="Mark Tognoli Realty"
              width={280}
              height={98}
              className="h-24 md:h-28 w-auto mb-6"
              loading="lazy"
            />
            <p className="text-brand-ivory/90 leading-relaxed max-w-md font-light">
              Discerning representation for buyers and sellers across San Mateo
              and the greater San Francisco Bay Area. A decade of market mastery,
              delivered with quiet precision.
            </p>
          </div>

          <div>
            <h4 className="text-[10px] tracking-[0.3em] uppercase text-primary mb-5">
              Navigate
            </h4>
            <ul className="space-y-3 text-sm font-light">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Buy", "/buy"],
                ["Sell", "/sell"],
                ["Contact", "/contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <Link
                    to={href}
                    className="text-brand-ivory/90 hover:text-primary transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] tracking-[0.3em] uppercase text-primary mb-5">
              Office
            </h4>
            <ul className="space-y-3 text-sm font-light text-brand-ivory/90">
              <li>San Mateo, California</li>
              <li>
                <a href="tel:+14157106922" className="hover:text-primary transition-colors">
                  (415) 710-6922
                </a>
              </li>
              <li>
                <a
                  href="mailto:marktognoli@gmail.com"
                  className="hover:text-primary transition-colors"
                >
                  marktognoli@gmail.com
                </a>
              </li>
              <li className="pt-2 text-xs tracking-widest uppercase text-brand-ivory/40">
                DRE# 01951190
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] tracking-[0.3em] uppercase text-primary mb-5">
              Brokerage
            </h4>
            <ul className="space-y-3 text-sm font-light text-brand-ivory/90">
              <li>DEAL Real Estate Services</li>
              <li>675 N First St ste 100D</li>
              <li>San Jose, CA, 95112</li>
              <li className="pt-2 text-xs tracking-widest uppercase text-brand-ivory/40">
                License #: 01951190
              </li>
              <li className="text-xs tracking-widest uppercase text-brand-ivory/40">
                Issued by: CA
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-ivory/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-brand-ivory/40 tracking-wider">
          <p>© {new Date().getFullYear()} Mark Tognoli Realty. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors uppercase tracking-[0.25em]">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-primary transition-colors uppercase tracking-[0.25em]">
              Terms &amp; Conditions
            </Link>
            <p className="uppercase tracking-[0.25em]">
              Equal Housing · DRE# 01951190
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
